import React, { useEffect, useState } from "react"
import "./JoinStudio.scss"
import { FieldGroup, FieldControl } from "react-reactive-form"
import { FormGroups } from "../../../components/ReusableComponents/FormGroups/FormGroups"
import {
  CustomSelectBox,
  TextInput,
} from "../../../components/UI/FormInput/FormInput"
import { selectIcon, SVG } from "../../../components/UI/selector"
import { gymInfo } from "../../../services/CallApi"
import { ErrorUI } from "../../../components/UI/Modals/Modals"
import { CheckValue } from "../../../services/CommonFunction"
import { getData } from "../../../services/CommonFormFunction"

const JoinStudio = ({ signUpForm, submitData, ...props }) => {
  const [gymDetail, setGymDetail] = useState({
    logo_thumb: selectIcon("joinStudio"),
    name: null,
  })

  useEffect(() => {
    console.log("gymDetail", gymDetail)
    if (CheckValue(gymDetail.gym_id) && !gymDetail.is_location_enabled) {
      submitData("memberShip")
    } else if (
      CheckValue(gymDetail.gym_id) &&
      gymDetail.location_list.length &&
      gymDetail.location_list.length === 1
    ) {
      signUpForm.patchValue({ location: [...gymDetail.location_list] })
    }
  }, [gymDetail])

  return (
    <div className="formDetailContainer">
      <ScreenHeader {...gymDetail} />
      {!CheckValue(gymDetail.gym_id) ? (
        <MemberShipCode
          signUpForm={signUpForm}
          setGymDetail={setGymDetail}
          submitData={submitData}
        >
          <p
            className="redSubHeading skip_button"
            onClick={() => submitData("skip")}
          >
            skip
          </p>
        </MemberShipCode>
      ) : gymDetail.is_location_enabled ? (
        <Location
          signUpForm={signUpForm}
          submitData={submitData}
          {...gymDetail}
        >
          <p
            className="redSubHeading skip_button"
            onClick={() => submitData("skip")}
          >
            skip
          </p>
        </Location>
      ) : null}
    </div>
  )
}

export default JoinStudio

const MemberShipCode = ({ signUpForm, setGymDetail, submitData, ...props }) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    if (signUpForm.get("membership_code").valid) {
      console.log("enter")
      gymInfo({ membership_code: signUpForm.value.membership_code }).then(
        (response) => {
          if (response.status) {
            console.log(response.data)
            if (
              response.data.is_location_enabled &&
              response.data.location_list.length &&
              response.data.location_list.length === 1
            ) {
              signUpForm.patchValue({
                location: [...response.data.location_list],
              })
            }
            setGymDetail(response.data)
          } else {
            ErrorUI(response.list)
          }
        }
      )
    }
  }
  return (
    <React.Fragment>
      <FieldGroup
        control={signUpForm}
        render={({ get, invalid }) => (
          <form onSubmit={handleSubmit} className="join_studio">
            <FormGroups>
              <FieldControl
                name="membership_code"
                render={TextInput}
                meta={{
                  label: "Enter membership code",
                  showLabel: false,
                  type: "text",
                  placeholder: "Enter membership code",
                  valid: true,
                  showError: true,
                }}
              />
            </FormGroups>
            <div className="submitDiv" style={{ justifyContent: "center" }}>
              <button
                className={`${
                  get("membership_code").invalid ? "disabled" : "enabled"
                }`}
                type="submit"
              >
                <p>Submit</p>
              </button>
            </div>
            {props.children}
          </form>
        )}
      />
    </React.Fragment>
  )
}
const Location = ({
  signUpForm,
  submitData,
  is_multiple_location_enabled,
  location_list,
  ...props
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(signUpForm.get("location").valid)
    console.log(signUpForm.get("location").value)
    console.log(signUpForm.get("location"))
    if (signUpForm.get("location").valid) {
      submitData("memberShip")
    }
  }
  return (
    <React.Fragment>
      <FieldGroup
        control={signUpForm}
        render={({ get, invalid }) => (
          <form onSubmit={handleSubmit}>
            <FormGroups>
              {location_list.length > 1 ? (
                <FieldControl
                  name="location"
                  render={CustomSelectBox}
                  meta={{
                    formKey: "location",
                    optionList: location_list,
                    showLabel: false,
                    label: "Location",
                    placeholder: "Select Location",
                    validation: true,
                    multiple: is_multiple_location_enabled,
                  }}
                />
              ) : (
                <div className="disabledEmail">
                  {getData(get("location").value, "name")}
                </div>
              )}
              {/* <FieldControl name="location" render={TextInput} meta={{ label: "Location", showLabel: false, type: "text", placeholder: "Select Location", placeHolderIcon: '', valid: true, showError: true }} /> */}
            </FormGroups>
            <div className="submitDiv" style={{ justifyContent: "center" }}>
              <button
                className={`${
                  get("location").invalid ? "disabled" : "enabled"
                }`}
                type="submit"
              >
                <p>Continue</p>
              </button>
            </div>
            {props.children}
          </form>
        )}
      />
    </React.Fragment>
  )
}

const ScreenHeader = ({ logo_thumb, name }) => {
  return (
    <div className="ScreenHeader">
      <img src={logo_thumb} alt={""} />
      {name ? <p className="gym_name">{name}</p> : null}
    </div>
  )
}
